module.exports = __webpack_public_path__ + "img/logo-netflix.a11d3b6b.svg";